export const getOptimizelyAbTrackingString = () => {
    const getActiveExperiments = () => {
        return (window &&
            window?.optimizelyEdge?.get('state').getActiveExperiments());
    };
    const tests = getActiveExperiments();
    if (!tests)
        return '';
    const experimentsText = Object.values(tests)
        .map((experiment) => experiment?.variation?.name + '_' + experiment?.name)
        .join(',');
    return experimentsText;
};
//# sourceMappingURL=optimizely.js.map